import { render, staticRenderFns } from "./MedicationClassDosageInterface.vue?vue&type=template&id=7a5232df&"
import script from "./MedicationClassDosageInterface.vue?vue&type=script&lang=js&"
export * from "./MedicationClassDosageInterface.vue?vue&type=script&lang=js&"
import style0 from "./MedicationClassDosageInterface.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTextField,VTooltip})
